// Nombre del conductor para mostrar. En Firestore conviven tres formas de doc
// en `drivers`: `name`, `firstName`/`lastName` y `first_name`/`last_name`
// (deviceAssignmentsService del API ya lee las dos últimas; deviceList
// devuelve el doc tal cual). El mapa concatenaba firstName + " " + lastName y
// a los que sólo tienen `name` los pintaba «undefined undefined»; el respaldo
// `|| "Sin asignar"` nunca entraba porque esa cadena no está vacía. Mismo
// criterio que driverName() de V5-realtime para las notificaciones.
export function driverDisplayName(
  d:
    | {
        name?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        first_name?: string | null;
        last_name?: string | null;
      }
    | null
    | undefined,
): string | null {
  if (!d) return null;
  // firstName/lastName primero: putDriver del API sólo actualiza ésos, así que
  // un `name` viejo dejaría al conductor con su nombre anterior tras renombrarlo.
  // `name` hace de nombre de pila, como en drivingHistoryService del API.
  const n = [d.firstName || d.first_name || d.name, d.lastName || d.last_name]
    .map((x) => x?.trim())
    .filter(Boolean)
    .join(" ");
  return n || null;
}
